import React from "react";
import {Button} from "@nextui-org/react";
import {FaTrash} from "react-icons/fa";

export const ShoppingItem = ({title, amount, total, deleteItem}) => {

    return(
        <>
            <div className="shop-group">
                <div>{title}</div>
                <div className="text-right">x{amount}</div>
                <div className="shop-total text-right"><b>Gs. {total}</b></div>
                <div className="shop-delete text-center"><Button isIconOnly color="transparent" onClick={deleteItem}><FaTrash/></Button></div>
            </div>
        </>
    );

}